// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickLink_noStyle__wA5Uw {
  color: inherit;
  text-decoration: inherit;
}

:hover.ClickLink_noStyle__wA5Uw {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/ClickLink/ClickLink.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wBAAA;AACF;;AACA;EACE,cAAA;AAEF","sourcesContent":[".noStyle {\n  color: inherit;\n  text-decoration: inherit;\n}\n:hover.noStyle {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noStyle": `ClickLink_noStyle__wA5Uw`
};
export default ___CSS_LOADER_EXPORT___;
